/**
 * Studio render counters.
 *
 * In development, counts are recorded automatically.
 * In any build, set localStorage.iswStudioRenderDebug = "1" and reload to
 * create window.__ISW_STUDIO_RENDER__ and log [studio-render] with console.log
 * (visible without Chrome's Verbose filter).
 *
 * Do not gate on `typeof process !== "undefined"`: webpack 5 may leave
 * `process` unset while still inlining NODE_ENV, which would disable counters
 * in an otherwise-valid development bundle.
 */
function readOptIn() {
  try {
    return typeof window !== "undefined" &&
      window.localStorage.getItem("iswStudioRenderDebug") === "1";
  } catch {
    return false;
  }
}

function isDevBuild() {
  return process.env.NODE_ENV !== "production";
}

function isEnabled() {
  return isDevBuild() || readOptIn();
}

function store() {
  if (typeof window === "undefined") return null;
  if (!window.__ISW_STUDIO_RENDER__) {
    window.__ISW_STUDIO_RENDER__ = {
      counts: {},
      nodeEnv: process.env.NODE_ENV,
    };
  }
  return window.__ISW_STUDIO_RENDER__;
}

const listeners = new Set();

function snapshotCounts() {
  return { ...(store()?.counts || {}) };
}

function emit() {
  const snap = snapshotCounts();
  listeners.forEach((listener) => {
    try {
      listener(snap);
    } catch {
      /* ignore */
    }
  });
}

if (typeof window !== "undefined" && isEnabled()) {
  store();
}

export function areStudioRenderCountsEnabled() {
  return isEnabled();
}

export function getStudioRenderCounts() {
  return snapshotCounts();
}

export function subscribeStudioRenderCounts(listener) {
  if (typeof listener !== "function") return () => {};
  listeners.add(listener);
  listener(snapshotCounts());
  return () => listeners.delete(listener);
}

export function resetStudioRenderCounts() {
  if (!isEnabled()) return;
  const s = store();
  if (!s) return;
  s.counts = {};
  emit();
}

export function noteStudioRender(name) {
  if (!isEnabled()) return;
  const s = store();
  if (!s) return;
  s.counts[name] = (s.counts[name] || 0) + 1;
  emit();
  if (readOptIn()) {
    console.log("[studio-render]", name, s.counts[name]);
  }
}
